import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AlertService } from "../services/alert.service";
import { EnvService } from "../services/env.service";
import { MatTableDataSource } from "@angular/material/table";
import { AuthService } from "../services/auth.service";

@Component({
  selector: "micro-class-code-detail",
  templateUrl: "./class-code-detail.component.html",
})
export class ClassCodeDetailComponent implements OnInit {
  dataSource = new MatTableDataSource<any>();
  @Input() classCodeId: any;
  @Output() persisted = new EventEmitter<any>();
  classCode: any;

  constructor(
    public auth: AuthService,
    private env: EnvService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
  ) {}

  ngOnInit(): void {
    if (this.classCodeId) {
      this.load(this.classCodeId);
    } else {
      this.route.params.subscribe((params: Params) => {
        params["id"] === "0" ? this.createNew() : this.load(params["id"]);
      });
    }
  }

  load(id: string): void {
    this.http
      .get(`${this.env.e.url}/domain/cmdbClassCodes/${id}`)
      .subscribe((data) => {
        this.classCode = data;
      });
  }

  createNew(): void {
    // TODO: This is a hack to get the form to work with a new object.  We should refactor the form to not require an id for a new object.
    this.classCode = {
      code: "",
      name: "",
      description: "Other",
      notes: "",
      companyId: this.auth.getCompanyId()
    };
  }

  save(): void {
    const isUpdate = !!this.classCode.id;
    const request = isUpdate
      ? this.http.put(
          `${this.env.e.url}/domain/cmdbClassCodes/${this.classCode.id}`,
          this.classCode,
        )
      : this.http.post(
          `${this.env.e.url}/domain/cmdbClassCodes`,
          this.classCode,
        );
    request.subscribe((data) => {
      this.classCode = data;
      this.alertService.info(
        `${isUpdate ? "Updated" : "Created"} ${this.classCode.name}`,
      );
      this.persisted.emit({ data, action: isUpdate ? "updated" : "added" });
    });
  }

  delete(): void {
    this.http
      .delete(`${this.env.e.url}/domain/cmdbClassCodes/${this.classCode.id}`)
      .subscribe(() => {
        this.persisted.emit({ data: this.classCode, action: "deleted" });
        this.alertService.info(`Deleted ${this.classCode.name}`);
        if (!this.classCodeId) {
          this.router.navigate(["/cmdbClassCodes"]);
        }
      });
  }

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.classCode.active = target.checked ? "Y" : "N";
  }
}
